import React from 'react'

import { LntModal } from '@app/components/base'

import { NewConnectionContractorsForm } from './NewConnectionContractorsForm'

import styles from './styles.module.scss'

import type { NewLinkContractorsModalProps } from './types'

export const NewConnectionContractorsModal: React.FC<NewLinkContractorsModalProps> = props => {
  const { onSubmit, ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      className={ styles.createConnectionContractors }
      title='Новая связь'
      footer={ null }
    >
      <NewConnectionContractorsForm onSubmit={ onSubmit } />
    </LntModal>
  )
}
